<template>
	<div>
		<div @click="launchFilePicker()">
			<slot></slot>
		</div>
		<input type="file" ref="file" style="display:none" @input="onFileChange(
          $event.target.name, $event.target.files)">
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		name: 'PictureUpload',
		props: {
			maxSize: {
				default: 10240
			},
			refresh: {
				required: false
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
			launchFilePicker(){
				this.$refs.file.click();
			},
			onFileChange(fieldName, file) {
				if (file.length > 0) {
					let imageFile = file[0];
					let size = imageFile.size / this.maxSize / this.maxSize;
					if (size > 1) {
						this.errorDialog = true;
						this.errorText = Vue.i18n.translate('messages.file_too_big');
					} else {
						let imageURL = URL.createObjectURL(imageFile);
						this.$emit('input', { imageFile, imageURL });
					}
				}
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/miscellaneous/PictureUpload.vue